import axios from "axios";

// Create instance with baseURL and default headers

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: false,
});

// Attach token dynamically before each request using interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle authentication and authorization errors
api.interceptors.response.use(
  (response) => {
    // Success response - return as is
    return response;
  },
  (error) => {
    if (error.response) {
      const { status } = error.response;

      // 401 Unauthorized - Token invalid or expired
      if (status === 401) {
        console.error('Authentication failed: Token invalid or expired');

        // Clear all auth data
        localStorage.removeItem('token');
        localStorage.removeItem('userRole');
        localStorage.removeItem('user');

        // Redirect to login
        window.location.href = '/';

        return Promise.reject(error);
      }

      // 403 Forbidden - User doesn't have permission for this resource
      // This happens when:
      // 1. User tampered with localStorage role
      // 2. User's role was changed on backend
      // 3. Admin tries to access user-only resource or vice versa
      if (status === 403) {
        console.error('Authorization failed: Insufficient permissions');
        console.error('This could mean:');
        console.error('1. localStorage role was tampered with');
        console.error('2. Your role was changed by an administrator');
        console.error('3. You do not have access to this resource');

        // Option 1: Clear and logout (strict security)
        // localStorage.clear();
        // window.location.href = '/';

        // Option 2: Just show error, let user stay (less strict)
        // The component will show the error message
        // Uncomment below to enable strict mode:
        /*
        localStorage.clear();
        window.location.href = '/';
        */

        return Promise.reject(error);
      }
    }

    // Other errors - pass through
    return Promise.reject(error);
  }
);

export default api;
